function getAge(birthday) {
	try {
		let bir = birthday.split("-");
		let d = new Date();
		let nowYear = d.getFullYear();
		let nowMonth = d.getMonth() + 1;
		let age = nowYear - bir[0];
		if (nowMonth < bir[1]) {
			age--;
		}
		if (age < 0) {
			age = 0;
		}
		return age;
	}catch (e) {
		return 0;
	}
}

function splitPhone(phone) {
	if(phone.length<1){
		return phone;
	}

	let p1 = phone.substr(0,3);
	let p2 = phone.substr(3,4);
	let p3 = phone.substr(7,4);
	let phoneStr = p1.concat("-",p2,"-",p3);
	return phoneStr;
}

/**
 * 格式化时间转为秒数
 */
function getSeconds(time) {
	let date = new Date(time);
	return date.getTime()/1000;
}


/**
 * 格式化时间转为毫秒数
 */
function getMillseconds(time) {
	let date = new Date(time);
	return date.getTime();
}

/**
 * 获取当前秒数
 */
function getNowSeconds() {
	let date = new Date();
	return date.getTime()/1000;
}

function extendHeadTail(array) {
	let newarray = new Array(2+array.length)
	newarray[0] = 0
	newarray[1+array.length] = 0
	for(let i=0;i<array.length;i++){
		newarray[i+1] = array[i]
	}
	return newarray
}

function maxNumber(array) {
	if(array.length == 0)
	  return null
	if(array.length == 1)
	  return array[0]
	let max = array[0]
	for(let i=1;i<array.length;i++){
	  if(max<array[i]){
		max = array[i]
	  }
	}
	return max
}

function maxNumberSum(array1,array2) {
	if(array1.length == 0)
	  return null
	if(array1.length == 1)
	  return array1[0]
	let max = array1[0]+array2[0]
	for(let i=1;i<array1.length;i++){
	  if(max<(array1[i]+array2[i])){
		max = array1[i]+array2[i]
	  }
	}
	return max
}

function extractLastComponentFromUrl(url) {
	const segments = url.split('/');
	const lastSegment = segments[segments.length - 1];
	return lastSegment;
}

export {
	getAge,
	splitPhone,
	getSeconds,
	getMillseconds,
	getNowSeconds,
	maxNumber,
	maxNumberSum,
	extendHeadTail,
	extractLastComponentFromUrl
}